import builder from '../builder';
import Attachment from '../../streamline-icons/light/attachment.svg';

export default builder('IconAttachmentLight', Attachment);
